import { isPlatformServer } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductosServicesService {
  Url: string;
    constructor(public http: HttpClient, @Inject(PLATFORM_ID) private platformId: object) {
        this.Url = isPlatformServer(this.platformId) ? environment.apiServerUrl : GlobalConstants.apiURL;
    }

    public async GetProductos(IdProd: any,Filtro: number) {
      if (Filtro === 0 && isPlatformServer(this.platformId)) {
        const { PRERENDER_PRODUCTS } = await import('./prerender-products.data');
        const cachedProduct = PRERENDER_PRODUCTS[String(IdProd)];
        if (cachedProduct) return cachedProduct;
      }
      let params = new HttpParams().set("IdProducto", IdProd).set("Filtro",Filtro);
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return await lastValueFrom(this.http.get(this.Url + '/productos', { params }));
    }

    public async getCatNavegacion(IdCat:any){
      let params = new HttpParams().set("IdCategoria", IdCat);
      return await lastValueFrom(this.http.get(this.Url + '/getcatnav',{params}));
    }

    public async ConsultaProductos(
      Categorias: string, Marcas: string, Nombre: string, SKU: string, Estatus: number,
      page: number = 1, pageSize: number = 12, order: number = 0
    ) {
      let params = new HttpParams()
        .set("Categorias", Categorias).set("Marcas", Marcas)
        .set("Nombre", Nombre).set("SKU", SKU)
        .set("Estatus", Estatus).set("admin", 0)
        .set("page", page).set("pageSize", pageSize).set("order", order);
      return await lastValueFrom(this.http.get<{data: any[], total: number}>(this.Url + '/consultaProdTienda', {params}));
    }

    public async BuscarSugerencias(nombre: string, limit: number = 6) {
      let params = new HttpParams()
        .set("Categorias", "0").set("Marcas", "").set("Nombre", nombre)
        .set("SKU", "").set("Estatus", 1).set("admin", 0)
        .set("pageSize", limit).set("suggestions", 1);
      return await lastValueFrom(this.http.get<{data: any[], total: number}>(this.Url + '/consultaProdTienda', {params}));
    }

    public async InsertOpinionProductos(DatosComentario:any) {
      let json = JSON.stringify(DatosComentario);
      let params = json;
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return await lastValueFrom(this.http.post(this.Url + '/addOpinion', params, { headers: headers }));
    }

    public async GetOpinionProductos(IdProd: any,IdCliente:number) {
      
      let params = new HttpParams().set("IdProductosModelos", IdProd).set("IdCliente",IdCliente.toString());
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return await lastValueFrom(this.http.get(this.Url + '/getOpinionProducto',{params}));
    }
 
}
